import React from 'react';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router';
import { Link } from 'react-router-dom';
import { useDashboardContext } from '../context';
import { useGlobalContext } from '../../../globalContext';

const MessageCenter = () => {
  const [expand, setExpand] = React.useState(false);
  const context = useGlobalContext();
  const messageContext = useDashboardContext();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (expand)
      context.getAllAlertsAsync(1);
  }, [expand]);
  
  const viewAllMessageHandler = () => {
    navigate('view_all_messages');
  };

  const messageBox = context.allMessage?.map((value, index) => {
    return (
      <Link key={index} to="view_all_messages" className="d-block">
        <div key={value.id} className="message-box d-flex justify-content-between mb-2">
          <div className="d-flex">
            <div className="message-img flex-shrink-0">
              {`${value?.fName?.slice(0, 1).toUpperCase()}${value?.lName
                ?.slice(0, 1)
                .toUpperCase()}`}
            </div>
            <div className="px-3 message-text">
              <p className="text-truncate">
                <strong>{value.subject}</strong>
              </p>
              <p className="text-truncate text-wrap">{value.message}</p>
            </div>
          </div>
          <div className="text-end flex-shrink-0">
            <p>{value.fName + ' ' + value.lName}</p>
            <p>{convertTimestamp(value.tStamp)}</p>
          </div>
        </div>
      </Link>
    );
  });
  return (
    <div className="additional-tab mb-3 ">
      <h4
        onClick={() => setExpand(!expand)}
        className="d-flex align-items-center justify-content-between">
        Message Center {`(${context?.notViewedAlerts})`}
        <span style={{ transform: `${expand ? 'rotate(90deg)' : 'rotate(0deg)'}` }}>
          <FontAwesomeIcon size="2xl" icon={faChevronRight} />
        </span>
      </h4>
      {expand && (
        <div className="mt-3">
          {messageBox}
          <div className="btn-group d-flex gap-3">
            <button onClick={viewAllMessageHandler} className="btn btn-castleWhite flex-fill">
              View All Messages
            </button>
            <button
              onClick={() => {
                messageContext.setSendEmailModal(!messageContext.sendEmailModal);
                messageContext.setIsReplayMessage(false);
              }}
              className="btn btn-castleRed flex-fill">
              Send Message
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default MessageCenter;

function convertTimestamp(timestamp) {
  const options = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric'
  };

  const formattedDate = new Date(timestamp).toLocaleString('en-US', options);
  return formattedDate.replace(/[/]/g, '-');
}
